module.exports = function () { /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 967
 ** module chunks = 0
 **/